ko.bindingHandlers.brwatch = {
    init: (element, valueAccessor) => {
        var observable = valueAccessor();

        if (observable) {
            var obs = document.getElementById("br-observer");

            let observer = new ResizeObserver((entries, observer) => {
                var current = $(obs).find(":visible")[0];
                observable(current.id);
            }).observe(document.body);
        }

        return { 'controlsDescendantBindings': false };
    }
}